import React, { useEffect, useState } from 'react';
import {useFetch} from '@utils'
import { Spin, message, Typography, Button, Tag, List } from 'antd';
import {LarpTable } from '@tables';
import { filterItems } from '../filters';
import TextEditorReadOnly from '../../../text/TextEditorReadOnly';
import { ItemWikiCsv } from './cvs';
import ItemWikiModal from './ItemWikiModal';
import {sortByString} from '../../../../utils/functions/Sorters';
//import { ItemWikiCsv } from './cvs';
const { Text } = Typography;

export default function ItemsWiki({
    tools
  }) {
     const [doFetch] = useFetch();
     const[isLoading, setIsLoading] = useState(true)
     const [searchValue, setSearchValue] = useState("");
     const [dataSource, setDataSource] = useState([]);
     const [result, setResult] = useState([])
     const [amountShown, setAmountShown] = useState(0);
     const [listSource, setListSource] = useState([]);
     const [isModalVisible, setIsModalVisible] = useState(false);
     const [selectedRecord, setSelectedRecord] = useState(undefined);

      useEffect(() => {
        if(result.length <= 0) {
          return;
        }
        const newDataSource = filterItems(result, searchValue);
        setDataSource(newDataSource);
        setAmountShown(newDataSource.length)
        setListSource(tableList(newDataSource, onRowClick))
      }, [result, searchValue])

      useEffect(() => {
        refresh();
          }, // eslint-disable-next-line
      [searchValue])

      function refresh()
      {
          const url = `/api/item/getwiki`
          doFetch(url)
          .then((response) => onLoaded(response.isSuccess, response.result))
  
          function onLoaded(isSuccess, result) { 
            if(isSuccess) {
              setResult(result);
              setIsLoading(false);
              return;
            }
            setResult([])
            message.error('Could not get items');
            setIsLoading(false);
          }
      }

      if(isLoading)
      {
          return <Spin />
      }

      const filterToolArray = tools.map(_ => {
        return {
          text: _.name,
          value: _.id
        }
      })
      filterToolArray.push({
        text: "No tool",
        value: null
      })

      const columns = [
        {
          title: 'Id',
          dataIndex: 'id',
          key: 'id',
          sorter: (a, b) => a.id - b.id,
          sortDirections: ['ascend', 'descend', 'ascend']
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            sorter: (a, b) => sortByString(a.name, b.name),
            sortDirections: ['ascend', 'descend', 'ascend']
        },
        {
            title: 'Description',
            key: 'description',
            render: (record) => {
               return (<TextEditorReadOnly content={record.description}/>)
             },
        },
        {
            title: 'Tool',
            key: 'tool',
            render: (record) => {
                return (<Text>
                  {record.tool.name}
                </Text>)
              },
            filters: filterToolArray,
            onFilter: (value, record) => record.tool?.id === value, 
        },
      {
        title: 'Tags',
        dataIndex: 'tags',
        key: 'tags', 
        render: (value, record) => {
          return (
            <>
              {record.isHerb && <Tag color={"green"}>Herb</Tag>}
              {record.isPotion && <Tag color={"yellow"}>Potion</Tag>}
            </>
          )
        }, //TODO: add proper filter to filter on tags here
        filters: [
          {
            text: 'Herb',
            value: 'Herb'
          },
          {
            text: 'Potion',
            value: 'Potion'
          },
        ],
        onFilter: (value, record) => {
          var found = false;
          if (value === 'Herb' && record.isHerb) {
            found = true;
        }
        if (value === 'Potion' && record.isPotion) {
          found = true;
        }
        return found;
      }
    },
        {
          title: 'Action',
          key: 'action', 
          render: (record) => {
            return(
              <>
                <Button type="text" onClick={() => onRowClick(record)}>View</Button>
              </>
          
          )
          }
        }
    ]

    function onRowClick(record) {
      setSelectedRecord(record);
      setIsModalVisible(true);
    }

    function onTableChange(pagination, filters, sorter, extra)
    {
      setAmountShown(extra.currentDataSource.length)
    }

    return (
      <>
        <Text>{amountShown} of {result.length} items shown </Text>
        <LarpTable 
          setSearchValue={setSearchValue}
          refresh={refresh}
          dataSource={dataSource}
          columns={columns}
          onTableChange={onTableChange}
          listSource={listSource}
          csv={ItemWikiCsv(dataSource)}
          onDoubleRowClick={onRowClick}
        />

      {isModalVisible && <ItemWikiModal 
          refresh={refresh}
          setIsModalVisible={setIsModalVisible}
          isModalVisible={isModalVisible}
          record={selectedRecord}
          tools={tools}
          allItems={result}
        />} 
      </>
    )
}

export function tableList(  
    list,   
    onRowClick,
  ) {
    return list.map(_ => {
      return (
              <List.Item
                style={{display:"flex", flexDirection:"column"}}
                onClick={() => onRowClick(_)}
              >
  
                <List.Item.Meta
                  style={{width:"100%"}}
                  title={`[${_.id}] ${_.name}`}
                  description={<>
                        {_.isHerb && <Tag color={"green"}>Herb</Tag>}
                        {_.isPotion && <Tag color={"yellow"}>Potion</Tag>}
                        {_.tool?.name && <Tag>{_.tool?.name}</Tag>}
                  </>}
                />
                  <TextEditorReadOnly content={_.description}/>
              </List.Item>
      )
    })
  }